import { Flex, Spinner } from '@kognitos/lattice';

export function FullPageLoader() {
  return (
    <Flex
      justify="center"
      align="center"
      className="w-full min-h-screen"
      data-testid="full-page-loader"
    >
      <Spinner size="xl" />
    </Flex>
  );
}
